import { createFileRoute } from '@tanstack/react-router';

import { F29LeerPage } from '@/features/f29/components/f29-leer/f29-leer-page';

export const Route = createFileRoute('/_app/f29/leer')({
  component: F29LeerPage,
});
